import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PriceInfoDialogParams } from '../shared/models/price-info-dialog.model';
import { I18nKeys } from '../shared/models/i18n.model';

@Component({
	selector: 'app-price-info-dialog',
	templateUrl: './price-info-dialog.html',
	styleUrl: './price-info-dialog.scss',
	standalone: false,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceInfoDialog {
	private readonly dialogRef = inject(MatDialogRef);
	protected readonly I18N = I18nKeys;
	public params: PriceInfoDialogParams = inject<PriceInfoDialogParams>(MAT_DIALOG_DATA);

	public onConfirmClicked() {
		this.dialogRef.close();
	}
}
